<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-top-group">
	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!-- 	     -->
			<!-- Message -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Message</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rMessage" maxlength="100" style="width: 650px" />
				</div>

				<div>
					<label class="column-item-label">Max 100 characters</label>
				</div>
			</div>

			<div class="date-group">
				<!-- 		    -->
				<!-- Start Date -->
				<!-- 		    -->
				<div class="column-item">
					<div>
						<label class="column-item-label">Start Date</label>
					</div>

					<div style="margin-left: 10px">
						<p-calendar
							[style]="{ width: '100%' }"
							[inputStyle]="{ width: '100%' }"
							[(ngModel)]="rStartDate"
							(ngModelChange)="onStartDateChange($event)"
							[showTime]="false"
							hourFormat="12"
							showIcon="true"
							inputId="rstartdate"
						></p-calendar>
					</div>
				</div>
				<!-- 		  -->
				<!-- End Date -->
				<!-- 		  -->
				<div class="column-item">
					<div style="margin-left: 20px">
						<label>End Date</label>
					</div>

					<div style="margin-left: 10px">
						<p-calendar
							[style]="{ width: '100%' }"
							[inputStyle]="{ width: '100%' }"
							[(ngModel)]="rEndDate"
							(ngModelChange)="onEndDateChange($event)"
							[showTime]="false"
							hourFormat="12"
							showIcon="true"
							inputId="renddate"
						></p-calendar>
					</div>
				</div>
			</div>

			<!--  	   	         -->
			<!-- Target Selector -->
			<!-- 		         -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Target</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedTargetSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedTarget"
						(ngModelChange)="onTargetChange($event)"
					>
						<option *ngFor="let r of lstTargetItems" [ngValue]="r">
							{{ r.BroadcastAlertTargetDesc }}
						</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="main-schools-group">
	<div>
		<!-- 		 -->
		<!-- Buttons -->
		<!-- 		 -->
		<div class="button-body-unassigned">
			<img style="margin-left: 0px" class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
			<label class="button-body-unassigned-text" style="margin-left: 25px"> {{ CountAssigned }} School(s) Assigned</label>

			<!-- 				   -->
			<!-- Display When Busy -->
			<!-- 				   -->
			<div style="margin-left: 15px; width: 20px" [style.display]="isBusy == true ? 'block' : 'none'">
				<img class="busy-img" src="assets/images/loading.gif" />
			</div>
		</div>

		<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
			<label>&#9900; Total Assigned: {{ CountAssigned }}</label
			><br />
			<label>&#9900; Total Unassigned: {{ CountUnAssigned }} </label><br />
			<label>&#9900; Schools in red are unassignable at your current security level.</label><br />
			<label>&#9900; Use ctl to add a column to the sort selection</label><br />
		</div>

		<!-- 					  -->
		<!-- Display UnAssigned   -->
		<!-- 					  -->
		<div class="table-main-body">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#dtAssigned
				[value]="lstSchoolItems"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="multiple"
				(onFilter)="onHandleFilter($event)"
				(onSort)="onHandleSort($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50, 100]"
			>
				<ng-template pTemplate="header">
					<!-- 				-->
					<!-- Filter Section -->
					<!-- 				-->
					<tr>
						<th class="fixwidth-11">
							<p-columnFilter field="IsSelected" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterSelected
										[ngModel]="value"
										[options]="lstSelected"
										optionValue="IsSelected"
										optionLabel="IsSelectedDesc"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<th class="fixwidth-11">
							<p-columnFilter field="IsUserSelectable" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterSelectable
										[ngModel]="value"
										[options]="lstSelectable"
										optionValue="IsSelectable"
										optionLabel="IsSelectableDesc"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<th class="fixwidth-14">
							<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<th>
							<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>
					</tr>

					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr>
						<th>
							<p-checkbox [(ngModel)]="isSelectAll" [binary]="true" (onChange)="onSelectAll($event)"></p-checkbox>
						</th>
						<th pSortableColumn="IsUserSelectable">Assignable<p-sortIcon field="IsUserSelectable"></p-sortIcon></th>
						<th class="fixwidth-14" pSortableColumn="SchoolNumber">School Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
						<th pSortableColumn="SchoolName">School Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rSchoolItem>
					<tr>
						<td>
							<div>
								<p-checkbox
									[(ngModel)]="rSchoolItem.IsSelected"
									[binary]="true"
									(onChange)="onRefreshAssignCounts()"
									[disabled]="rSchoolItem.IsUserSelectable == false"
								></p-checkbox>
							</div>
						</td>

						<td>
							<div class="fixwidth-11">
								<i
									class="pi"
									[ngClass]="{
										'pi-check-circle img-isSelectable': rSchoolItem.IsUserSelectable,
										'pi-ban img-isNotSelectable': !rSchoolItem.IsUserSelectable
									}"
								></i>
							</div>
						</td>

						<td>
							<div
								class="fixwidth-14"
								[ngClass]="{
									IsSelectable: rSchoolItem.IsUserSelectable == true,
									IsNotSelectable: rSchoolItem.IsUserSelectable == false
								}"
							>
								{{ rSchoolItem.SchoolNumber }}
							</div>
						</td>

						<td>
							<div
								[ngClass]="{
									IsSelectable: rSchoolItem.IsUserSelectable == true,
									IsNotSelectable: rSchoolItem.IsUserSelectable == false
								}"
							>
								{{ rSchoolItem.SchoolName }}
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 						       		-->
		<!-- Display When No UnAssigned Schools -->
		<!-- 						       		-->
		<div style="padding: 20px" [style.display]="lstSchoolItems.length < 1 && isBusy == false ? 'block' : 'none'">
			<label>No Schools To Assign...</label>
		</div>
	</div>
</div>

<!--				-->
<!-- Error Message  -->
<!--				-->
<div class="main-error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
	<div class="error-div">
		<label class="error-message">{{ ErrorMessage }}</label>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onUpdate()" [disabled]="isBusy == true">Update</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
